import { UserService } from "@/services";
import { util } from "@/helpers";
import router from "@/router/index";
import sessionStorageUtils from "@/utils/session-storage";
import { clearMemberIdRequestID } from "@/router";
import { ERROR_CODES, VUEX_COMMON } from "@/utils/constants";
const { MIDERR_025 } = ERROR_CODES;
const { 
  SET_STATUS, 
  SET_IS_FETCHING, 
  SET_RESPONSE, 
  SHOW_ALERT, 
  REQUEST_ID_STORAGE_KEY, 
  LOGGED_IN_STORAGE_KEY 
} = VUEX_COMMON;

export default {
  async profileFlow({ commit }, payload) {
    commit(SET_STATUS, 0);
    commit(SET_IS_FETCHING, true);
    try {
      const { data } = await UserService.viewProfile(payload);
      if (data?.successFlag) {
        commit(SET_STATUS, 1);
        commit(SET_RESPONSE, data);
        sessionStorageUtils.setItem(LOGGED_IN_STORAGE_KEY, true);
        clearMemberIdRequestID();
        const requestID = data.requestID;
        if (!sessionStorageUtils.getItem(REQUEST_ID_STORAGE_KEY)) {
          sessionStorageUtils.setItem(REQUEST_ID_STORAGE_KEY, requestID);
        }
        return data;
      } else {
        sessionStorageUtils.deleteItem(REQUEST_ID_STORAGE_KEY);
        sessionStorageUtils.deleteItem(LOGGED_IN_STORAGE_KEY);
        router.push("/login");
        commit(SET_STATUS, 2);
        if (![MIDERR_025].includes(data?.errCode)) {
          // const errMsg = util.getUiErrorByCode(data?.errCode);
          // commit(
          //   SHOW_ALERT,
          //   {
          //     message: errMsg,
          //     type: "error",
          //   },
          //   { root: true }
          // );
          document.getElementById("app").scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (e) {
      sessionStorageUtils.deleteItem(REQUEST_ID_STORAGE_KEY);
      sessionStorageUtils.deleteItem(LOGGED_IN_STORAGE_KEY);
      router.push("/login");
      commit(SET_STATUS, 2);
      const errCode = e.response?.data?.errCode ?? e.response.status;
      if (![MIDERR_025].includes(errCode)) {
        // const errMsg = util.getUiErrorByCode(errCode);
        // commit(
        //   SHOW_ALERT,
        //   {
        //     message: errMsg,
        //     type: "error",
        //   },
        //   { root: true }
        // );
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      }
      return e?.response?.data;
    } finally {
      commit(SET_IS_FETCHING, false);
    }
  },

  async logoutFlow({ commit }, payload) {
    commit(SET_STATUS, 0);
    commit(SET_IS_FETCHING, true);
    try {
      const { data } = await UserService.logout(payload);
      if (data?.successFlag) {
        commit(SET_STATUS, 1);
        commit(SET_RESPONSE, data);
        return data;
      } else {
        commit(SET_STATUS, 2);
        console.log("err", data?.errCode);
        const errMsg = util.getUiErrorByCode(data?.errCode);
        commit(
          SHOW_ALERT,
          {
            message: errMsg,
            type: "error",
          },
          { root: true }
        );
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      }
    } catch (e) {
      commit(SET_STATUS, 2);
      // console.error(e);
      commit(SET_RESPONSE, e.response?.data);
      const errCode = e.response?.data?.errCode ?? e.response.status;
      const errMsg = util.getUiErrorByCode(errCode);
      commit(
        SHOW_ALERT,
        {
          message: errMsg,
          type: "error",
        },
        { root: true }
      );
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      return e?.response?.data;
    } finally {
      commit(SET_IS_FETCHING, false);
    }
  },
};
